export default {"src":"/_next/static/media/negative-polygon.a3410ab7.svg","height":15,"width":18};